import moment from "moment-timezone";

import { DeclarationDecline } from "../api/graphql/schema.generated";

export const declarationDeclinesSorter = (
  a: DeclarationDecline,
  b: DeclarationDecline
): number => (moment(a.createdAt).isBefore(b.createdAt) ? 1 : -1);
